import { render, staticRenderFns } from "./Orgao.vue?vue&type=template&id=4b5772b2&scoped=true&"
import script from "./Orgao.vue?vue&type=script&lang=js&"
export * from "./Orgao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5772b2",
  null
  
)

export default component.exports